/**
 * Чистый доход (NET)
 * ==================
 *
 * NET считает сервер (инапы: gross / (1 + VAT страны покупки) × 0.70, реклама без
 * изменений) и отдаёт рядом с gross: поле `<имя>Net` рядом с `<имя>`.
 * Клиент только выбирает, какое из двух показать. Никаких констант здесь нет:
 * если NET-поля в ответе нет (старый кэш сервера), остаётся gross.
 */

const NET_SUFFIX = 'Net';

/** Число или числовая строка, не NaN/Infinity. null/undefined/'' — не NET. */
export const hasNetValue = (value) =>
  value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));

/** NET, если сервер его прислал, иначе gross. */
export const pickNet = (gross, net) => (hasNetValue(net) ? Number(net) : gross);

/**
 * Копия объекта, где каждое `<ключ>` заменено значением `<ключ>Net`, если оно есть.
 * Работает на одном уровне, вложенные объекты возвращаются как есть.
 */
export const swapNetFields = (obj) => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return obj;
  }

  const result = { ...obj };
  Object.keys(obj).forEach((key) => {
    if (!key.endsWith(NET_SUFFIX)) return;
    const base = key.slice(0, -NET_SUFFIX.length);
    if (base in obj && hasNetValue(obj[key])) {
      result[base] = Number(obj[key]);
    }
  });
  return result;
};
